import { parsePhoneNumber } from 'awesome-phonenumber';

import { PostalAddress, PriceSpecification } from '#/__generated__/graphql/graphql';
import { STATE_LIST } from '#/constants/malaysia-state-list';

export function formatDate(date: string | Date, options?: Intl.DateTimeFormatOptions) {
  return new Intl.DateTimeFormat(undefined, options).format(
    typeof date === 'string' ? new Date(date) : date,
  );
}

export function formatTextAsNumberOnly(value: string) {
  value = value.replace(/\D/g, '');
  return Number(value).toString();
}

export function formatTextUppercase(value: string) {
  return value.toUpperCase();
}

// export function formatMyKad(value: string) {
//   try {
//     return mykad.format(value);
//   } catch {}
//   return value;
// }

export function formatAddress(
  postalAddress: PostalAddress,
  options?: { exclude?: Array<keyof PostalAddress> },
) {
  const exclude = options?.exclude;
  const addressRegion = STATE_LIST.find((o) => o.code === postalAddress.addressRegion)?.name;
  return [
    exclude?.includes('streetAddress') ? undefined : postalAddress.streetAddress,
    exclude?.includes('addressLocality') ? undefined : postalAddress.addressLocality,
    exclude?.includes('postalCode') ? undefined : postalAddress.postalCode,
    exclude?.includes('addressRegion') ? undefined : addressRegion,
    exclude?.includes('addressCountry') ? undefined : postalAddress.addressCountry,
  ]
    .filter(Boolean)
    .join(', ');
}

export function formatMoney(amount: PriceSpecification) {
  if (!amount.price) {
    throw new Error('`price` must be defined');
  }
  if (!amount.priceCurrency) {
    throw new Error('`priceCurrency` must be defined');
  }

  const numberFormat = new Intl.NumberFormat(undefined, {
    currency: amount.priceCurrency,
    currencyDisplay: 'narrowSymbol',
    style: 'currency',
  });

  return numberFormat.format(Number(amount.price));
}

export const formatPercentage = new Intl.NumberFormat(undefined, {
  style: 'percent',
}).format;

export function formatPhoneNumber(value: string, regionCode?: string) {
  const phoneNumber = parsePhoneNumber(value, { regionCode });
  return phoneNumber.valid ? phoneNumber.number.input : value;
}

export function formatBytes(bytes: number, decimals?: number) {
  if (bytes === 0) {
    return '0 kb';
  }
  const k = 1024,
    dm = decimals ?? 2,
    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export function formatUnitCode(unitCode: string) {
  switch (unitCode) {
    case 'CMT':
      return 'cm';
    case 'FOT':
      return 'foot';
    case 'KGM':
      return 'kg';
    case 'CCT':
      return 'tonne(s)';
    default:
      throw new Error('Invalid Unit Code');
  }
}
